import {Inject, Pipe, PipeTransform} from '@angular/core';
import {Locale} from '@aztrix/models';
import {BehaviorSubject} from 'rxjs';

import {LOCALE} from '@aztrix/translate';
import {formatTime} from '../util/date.util';

/**
 * Transforms a Date object into a time formatted string.
 **/
@Pipe({name: 'formatTime', pure: false})
export class FormatTimePipe implements PipeTransform {
  constructor(
    @Inject(LOCALE)
    private _locale$: BehaviorSubject<Locale>
  ) {}

  transform(value?: string | number | Date | null): string {
    return formatTime(value, this._locale$.value);
  }
}
